/* DeVAR Shopping Experience Switcher Controller */

document.addEventListener('DOMContentLoaded', async () => {
  // Sync the country labels in dropdown list first (synchronously)
  updateDropdownLabels();
  
  // Load exchange rates and convert prices
  await loadExchangeRates();
  convertAllPricesOnPage();
  
  // Setup MutationObserver to convert dynamically injected elements (like Bundler.app widget)
  initAppMutationObserver();

  initShoppingMode();
  initModalActions();
  initDarkMode();
  initCountrySearch();
  initDynamicHeaderHeights();
});

/**
 * Initialize Shopping Mode (B2C vs B2B)
 */
function initShoppingMode() {
  // Sync the html/body class immediately based on localStorage
  const activeMode = localStorage.getItem('devar-shopping-mode') || 'retail';
  
  // Update desktop pills selector UI
  const desktopBtns = document.querySelectorAll('.shopping-mode-switcher-desktop .switcher-btn');
  desktopBtns.forEach(btn => {
    if (btn.getAttribute('data-mode') === activeMode) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  // Update mobile headers & drawer selectors text
  const mobileLabel = activeMode === 'business' ? 'For Business' : 'For Me';
  const mobileTextElems = document.querySelectorAll('.mobile-switcher-mode-text');
  mobileTextElems.forEach(el => {
    el.textContent = mobileLabel;
  });

  // Style comparisons in the modal cards
  const modalCards = document.querySelectorAll('.shopping-mode-card');
  modalCards.forEach(card => {
    if (card.getAttribute('data-mode') === activeMode) {
      card.classList.add('active');
    } else {
      card.classList.remove('active');
    }
  });

  // If in B2B Mode, ensure B2B elements render correctly
  if (activeMode === 'business') {
    initBundlerAppIntegration();
  }
}

/**
 * Toggle Modal open/closed and switch options
 */
function initModalActions() {
  const modalOverlay = document.getElementById('shopping-mode-modal');
  const openTriggers = document.querySelectorAll('[data-mode-modal-trigger]');
  const closeTriggers = document.querySelectorAll('[data-mode-modal-close]');
  
  // Open modal
  openTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      modalOverlay?.classList.add('active');
    });
  });

  // Close modal
  closeTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      modalOverlay?.classList.remove('active');
    });
  });

  // Selecting cards inside the modal or clicking headers
  const desktopBtns = document.querySelectorAll('.shopping-mode-switcher-desktop .switcher-btn[data-mode]');
  desktopBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const newMode = btn.getAttribute('data-mode');
      const currentMode = localStorage.getItem('devar-shopping-mode') || 'retail';
      if (newMode !== currentMode) {
        triggerLoaderAndSwitch(newMode);
      }
    });
  });

  // Handle mobile select box country change to save preferences
  const mobileSelect = document.querySelector('.mobile-country-select');
  if (mobileSelect) {
    mobileSelect.addEventListener('change', function() {
      const countryCode = this.value;
      localStorage.setItem('devar-selected-country', countryCode);
      this.form.submit();
    });
  }
}

/**
 * Perform transitions and switch mode
 */
function triggerLoaderAndSwitch(newMode) {
  const loaderOverlay = document.getElementById('shopping-loader');
  const modalOverlay = document.getElementById('shopping-mode-modal');
  
  // Close the open modal first
  modalOverlay?.classList.remove('active');
  
  // Show the loader screen
  if (loaderOverlay) {
    loaderOverlay.classList.add('active');
  }

  // Duration editable from settings, defaults to 2000ms
  const duration = parseInt(loaderOverlay?.getAttribute('data-duration') || '2000');
  
  setTimeout(() => {
    localStorage.setItem('devar-shopping-mode', newMode);
    
    // Cookie fallback in case backend app integrations require it
    document.cookie = `devar_shopping_mode=${newMode}; path=/; max-age=31536000;`;
    
    window.location.reload();
  }, duration);
}

/**
 * Integrates with Bundler App dynamic configurations
 */
function initBundlerAppIntegration() {
  // Listen for the Bundler App load event if supported
  document.addEventListener('bundler-loaded', () => {
    syncBundlerOffers();
  });

  // Periodically check for Bundler data object if injected
  let checkInterval = setInterval(() => {
    if (window.bundlerApp || window.bundler_discounts || document.querySelector('.bundler-target-element')) {
      syncBundlerOffers();
      clearInterval(checkInterval);
    }
  }, 500);

  // Clear check after 5 seconds to prevent memory leak
  setTimeout(() => clearInterval(checkInterval), 5000);
}

/**
 * Sync prices and tiers from Bundler App object (if active)
 */
function syncBundlerOffers() {
  // If Bundler App provides real offers in window context, read them
  if (window.bundler_discounts && Array.isArray(window.bundler_discounts)) {
    const cards = document.querySelectorAll('.b2b-bundle-card');
    window.bundler_discounts.forEach((offer, index) => {
      const card = cards[index];
      if (card && offer.quantity && offer.discount_percent) {
        // Dynamically update card markup from Bundler App settings
        const qtyEl = card.querySelector('.b2b-bundle-qty');
        const saveEl = card.querySelector('.b2b-bundle-save');
        if (qtyEl) qtyEl.textContent = `Buy ${offer.quantity}`;
        if (saveEl) saveEl.textContent = `Save ${offer.discount_percent}%`;
      }
    });
  }
}

/**
 * Handle Buy Now click for Wholesale volume discount tiers
 */
function buyB2BBundle(variantId, quantity) {
  // Show loader during add-to-cart redirect
  const loaderOverlay = document.getElementById('shopping-loader');
  if (loaderOverlay) {
    loaderOverlay.classList.add('active');
    const titleEl = loaderOverlay.querySelector('.shopping-loader-title');
    const descEl = loaderOverlay.querySelector('.shopping-loader-subtitle');
    if (titleEl) titleEl.textContent = "Processing Bulk Offer...";
    if (descEl) descEl.textContent = "Adding required quantity to your business cart.";
  }

  // Check if Bundler App's custom addToCart method is available
  if (typeof window.bundlerAddToCart === 'function') {
    window.bundlerAddToCart(variantId, quantity);
  } else if (window.Bundler && typeof window.Bundler.addBundleToCart === 'function') {
    window.Bundler.addBundleToCart(variantId, quantity);
  } else {
    // Add required quantity directly using Shopify Cart API
    const itemsData = [{
      id: parseInt(variantId),
      quantity: parseInt(quantity),
      properties: {
        '_wholesale_mode': 'true',
        '_b2b_bundle': `Buy ${quantity}`
      }
    }];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: itemsData })
    })
    .then(res => res.json())
    .then(() => {
      // Redirect directly to checkout in B2B mode, or open cart
      window.location.href = '/cart';
    })
    .catch(err => {
      console.error("Error adding B2B bundle to cart:", err);
      window.location.reload();
    });
  }
}

// Export for global HTML button clicks
window.buyB2BBundle = buyB2BBundle;
window.triggerLoaderAndSwitch = triggerLoaderAndSwitch;

// Shopify Native Localization Helper (updated for client-side multi-currency)
window.selectHeaderCountry = function(countryCode) {
  const currencyCode = countryToCurrencyMap[countryCode] || 'INR';
  localStorage.setItem('devar-selected-country', countryCode);
  
  // Show loader during reload
  const loaderOverlay = document.getElementById('shopping-loader');
  if (loaderOverlay) {
    loaderOverlay.classList.add('active');
    const titleEl = loaderOverlay.querySelector('.shopping-loader-title');
    const descEl = loaderOverlay.querySelector('.shopping-loader-subtitle');
    if (titleEl) titleEl.textContent = "Updating Currency...";
    if (descEl) descEl.textContent = `Switching storefront currency to ${currencyCode}.`;
  }
  
  const form = document.getElementById('HeaderCountryForm');
  if (form) {
    const input = form.querySelector('input[name="country_code"]');
    if (input) {
      input.value = countryCode;
      form.submit();
    }
  } else {
    window.location.reload();
  }
};

// Initialize currency selector dropdown and change listeners
document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.country-selector-trigger');
  const list = document.getElementById('HeaderCountryList');
  if (trigger && list) {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isVisible = list.style.display === 'block';
      list.style.display = isVisible ? 'none' : 'block';
    });
    
    document.addEventListener('click', () => {
      list.style.display = 'none';
    });
  }

  // Bind change event on mobile selects to save state and show loader
  const mobileSelects = document.querySelectorAll('.mobile-country-select');
  mobileSelects.forEach(select => {
    select.addEventListener('change', (e) => {
      const countryCode = e.target.value;
      const currencyCode = countryToCurrencyMap[countryCode] || 'INR';
      localStorage.setItem('devar-selected-country', countryCode);
      
      const loaderOverlay = document.getElementById('shopping-loader');
      if (loaderOverlay) {
        loaderOverlay.classList.add('active');
        const titleEl = loaderOverlay.querySelector('.shopping-loader-title');
        const descEl = loaderOverlay.querySelector('.shopping-loader-subtitle');
        if (titleEl) titleEl.textContent = "Updating Currency...";
        if (descEl) descEl.textContent = `Switching storefront currency to ${currencyCode}.`;
      }
    });
  });
});

// Mapping country ISO codes to native currency ISO codes
const countryToCurrencyMap = {
  "AF": "AFN", "AX": "EUR", "AL": "ALL", "DZ": "DZD", "AD": "EUR", "AO": "AOA", "AI": "XCD", "AG": "XCD", "AR": "ARS", "AM": "AMD",
  "AW": "AWG", "AU": "AUD", "AT": "EUR", "AZ": "AZN", "BS": "BSD", "BH": "BHD", "BD": "BDT", "BB": "BBD", "BY": "BYN", "BE": "EUR",
  "BZ": "BZD", "BJ": "XOF", "BM": "BMD", "BT": "BTN", "BO": "BOB", "BA": "BAM", "BW": "BWP", "BR": "BRL", "IO": "USD", "VG": "USD",
  "BN": "BND", "BG": "BGN", "BF": "XOF", "BI": "BIF", "KH": "KHR", "CM": "XAF", "CA": "CAD", "CV": "CVE", "KY": "KYD", "CF": "XAF",
  "TD": "XAF", "CL": "CLP", "CN": "CNY", "CX": "AUD", "CC": "AUD", "CO": "COP", "KM": "KMF", "CG": "XAF", "CD": "CDF", "CK": "NZD",
  "CR": "CRC", "CI": "XOF", "HR": "EUR", "CU": "CUP", "CW": "ANG", "CY": "EUR", "CZ": "CZK", "DK": "DKK", "DJ": "DJF", "DM": "XCD",
  "DO": "DOP", "EC": "USD", "EG": "EGP", "SV": "USD", "GQ": "XAF", "ER": "ERN", "EE": "EUR", "SZ": "SZL", "ET": "ETB", "FK": "FKP",
  "FO": "DKK", "FJ": "FJD", "FI": "EUR", "FR": "EUR", "GF": "EUR", "PF": "XPF", "TF": "EUR", "GA": "XAF", "GM": "GMD", "GE": "GEL",
  "DE": "EUR", "GH": "GHS", "GI": "GIP", "GR": "EUR", "GL": "DKK", "GD": "XCD", "GP": "EUR", "GT": "GTQ", "GG": "GBP", "GN": "GNF",
  "GW": "XOF", "GY": "GYD", "HT": "HTG", "HN": "HNL", "HK": "HKD", "HU": "HUF", "IS": "ISK", "IN": "INR", "ID": "IDR", "IQ": "IQD",
  "IE": "EUR", "IM": "GBP", "IL": "ILS", "IT": "EUR", "JM": "JMD", "JP": "JPY", "JE": "GBP", "JO": "JOD", "KZ": "KZT", "KE": "KES",
  "KI": "AUD", "KP": "KPW", "KR": "KRW", "KW": "KWD", "KG": "KGS", "LA": "LAK", "LV": "EUR", "LB": "LBP", "LS": "LSL", "LR": "LRD",
  "LY": "LYD", "LI": "CHF", "LT": "EUR", "LU": "EUR", "MO": "MOP", "MG": "MGA", "MW": "MWK", "MY": "MYR", "MV": "MVR", "ML": "XOF",
  "MT": "EUR", "MQ": "EUR", "MR": "MRU", "MU": "MUR", "YT": "EUR", "MX": "MXN", "FM": "USD", "MD": "MDL", "MC": "EUR", "MN": "MNT",
  "ME": "EUR", "MS": "XCD", "MA": "MAD", "MZ": "MZN", "MM": "MMK", "NA": "NAD", "NR": "AUD", "NP": "NPR", "NL": "EUR", "NC": "XPF",
  "NZ": "NZD", "NI": "NIO", "NE": "XOF", "NG": "NGN", "NU": "NZD", "NF": "AUD", "MP": "USD", "NO": "NOK", "OM": "OMR", "PK": "PKR",
  "PW": "USD", "PS": "ILS", "PA": "PAB", "PG": "PGK", "PY": "PYG", "PE": "PEN", "PH": "PHP", "PN": "NZD", "PL": "PLN", "PT": "EUR",
  "PR": "USD", "QA": "QAR", "RE": "EUR", "RO": "RON", "RU": "RUB", "RW": "RWF", "WS": "WST", "SM": "EUR", "ST": "STN", "SA": "SAR",
  "SN": "XOF", "RS": "RSD", "SC": "SCR", "SL": "SLL", "SG": "SGD", "SX": "ANG", "SK": "EUR", "SI": "EUR", "SB": "SBD", "SO": "SOS",
  "ZA": "ZAR", "GS": "GBP", "SS": "SSP", "ES": "EUR", "LK": "LKR", "BL": "EUR", "SH": "SHP", "KN": "XCD", "LC": "XCD", "MF": "EUR",
  "PM": "EUR", "VC": "XCD", "SD": "SDG", "SR": "SRD", "SJ": "NOK", "SE": "SEK", "CH": "CHF", "SY": "SYP", "TW": "TWD", "TJ": "TJS",
  "TZ": "TZS", "TH": "THB", "TL": "USD", "TG": "XOF", "TK": "NZD", "TO": "TOP", "TT": "TTD", "TA": "GBP", "TN": "TND", "TR": "TRY",
  "TM": "TMT", "TC": "USD", "TV": "AUD", "UM": "USD", "UG": "UGX", "UA": "UAH", "AE": "AED", "GB": "GBP", "US": "USD", "UY": "UYU",
  "UZ": "UZS", "VU": "VUV", "VE": "VES", "VN": "VND", "WF": "XPF", "EH": "MAD", "YE": "YER", "ZM": "ZMW", "ZW": "ZWL"
};

// Mapping currency ISO codes to native symbols
const currencySymbols = {
  "USD": "$", "EUR": "€", "GBP": "£", "AUD": "A$", "CAD": "C$", "JPY": "¥", "INR": "₹", "AED": "د.إ", "SAR": "ر.س", "AFN": "؋",
  "ALL": "L", "DZD": "DA", "AOA": "Kz", "ARS": "$", "AMD": "֏", "BDT": "৳", "BHD": "BD", "BIF": "FBu", "BMD": "$", "BND": "$",
  "BOB": "Bs", "BAM": "KM", "BWP": "P", "BRL": "R$", "KHR": "៛", "CVE": "$", "CLP": "$", "CNY": "¥", "COP": "$", "KMF": "CF",
  "CDF": "FC", "CRC": "₡", "CZK": "Kč", "DKK": "kr", "DJF": "Fdj", "DOP": "RD$", "EGP": "EGP", "ETB": "Br", "FKP": "£", "FJD": "$",
  "GMD": "D", "GEL": "₾", "GHS": "GH₵", "GIP": "£", "GTQ": "Q", "GNF": "FG", "GYD": "$", "HTG": "G", "HNL": "L", "HKD": "$",
  "HUF": "Ft", "ISK": "kr", "IDR": "Rp", "ILS": "₪", "JMD": "J$", "JOD": "JD", "KZT": "₸", "KES": "KSh", "KWD": "KD", "KGS": "сом",
  "LAK": "₭", "LBP": "L£", "LSL": "L", "LRD": "$", "LYD": "LD", "MOP": "MOP$", "MGA": "Ar", "MWK": "MK", "MYR": "RM", "MVR": "Rf",
  "MRU": "UM", "MUR": "₨", "MXN": "$", "MDL": "L", "MNT": "₮", "MAD": "DH", "MZN": "MT", "MMK": "K", "NAD": "$", "NPR": "₨",
  "NZD": "$", "NIO": "C$", "NGN": "₦", "NOK": "kr", "OMR": "RO", "PKR": "₨", "PAB": "B/.", "PGK": "K", "PYG": "₲", "PEN": "S/.",
  "PHP": "₱", "PLN": "zł", "QAR": "QR", "RON": "lei", "RUB": "₽", "RWF": "FRw", "WST": "T", "STN": "Db", "RSD": "din", "SCR": "₨",
  "SLL": "Le", "SGD": "$", "SOS": "Sh", "ZAR": "R", "LKR": "Rs", "SSP": "£", "SEK": "kr", "CHF": "CHF", "TWD": "NT$", "TJS": "SM",
  "TZS": "TSh", "THB": "฿", "TOP": "T$", "TTD": "TT$", "TND": "DT", "TRY": "₺", "UGX": "USh", "UAH": "₴", "UYU": "$U", "UZS": "so'm",
  "VUV": "VT", "VES": "Bs.S", "VND": "₫", "YER": "﷼", "ZMW": "ZK", "XCD": "$"
};

let exchangeRates = null;

// Fetch live exchange rates from cached CDN
async function loadExchangeRates() {
  const cachedRates = sessionStorage.getItem('devar-exchange-rates');
  if (cachedRates) {
    exchangeRates = JSON.parse(cachedRates);
    return;
  }
  try {
    const res = await fetch('https://open.er-api.com/v6/latest/INR');
    const data = await res.json();
    if (data && data.rates) {
      exchangeRates = data.rates;
      sessionStorage.setItem('devar-exchange-rates', JSON.stringify(data.rates));
    }
  } catch (err) {
    console.error("Failed to fetch live exchange rates:", err);
    // Fallback static conversion rates
    exchangeRates = {
      "INR": 1.0, "USD": 0.012, "EUR": 0.011, "GBP": 0.0094, "AUD": 0.018, "CAD": 0.016, "JPY": 1.76, "AED": 0.044, "SAR": 0.045
    };
  }
}

function convertPrice(inrAmount, targetCurrency) {
  if (!exchangeRates || !exchangeRates[targetCurrency]) return inrAmount;
  return inrAmount * exchangeRates[targetCurrency];
}

// Convert all price elements on the page client-side
function convertAllPricesOnPage() {
  const targetCountry = localStorage.getItem('devar-selected-country') || 'IN';
  const targetCurrency = countryToCurrencyMap[targetCountry] || 'INR';
  
  // Get active flag emoji and name from list
  let flag = '🇮🇳';
  let countryName = 'INDIA';
  const selectedItem = document.querySelector(`.localization-country-item[data-value="${targetCountry}"] a`);
  if (selectedItem) {
    const itemText = selectedItem.textContent.trim();
    const itemCodePoint = itemText.codePointAt(0);
    const itemHasFlag = itemCodePoint >= 0x1F1E6 && itemCodePoint <= 0x1F1FF;
    flag = itemHasFlag ? itemText.substring(0, 4).trim() : '';
    
    const parts = itemText.split('(');
    const namePart = parts[0].trim();
    countryName = itemHasFlag ? namePart.substring(4).trim().toUpperCase() : namePart.toUpperCase();
  }
  
  // Update header trigger button pill text to show active currency
  const triggerBtn = document.querySelector('.country-selector-trigger');
  if (triggerBtn) {
    triggerBtn.innerHTML = `<span>${flag}</span> ${countryName} | ${targetCurrency} <span style="font-size: 0.5rem; margin-left: 2px;">▼</span>`;
  }
  
  // Update mobile selector trigger pill text
  const mobileTriggerText = document.querySelector('.mobile-region-text');
  if (mobileTriggerText) {
    mobileTriggerText.innerHTML = `${flag} ${targetCountry} | ${targetCurrency}`;
  }
  
  const priceElements = document.querySelectorAll(
    '.price-val, .compare-val, .product-card-price, .product-card-compare-price, .b2b-bundle-price-final, .b2b-bundle-price-compare, .b2b-bundle-price-unit, .mega-menu-product-info .price, .mega-menu-product-card .price, [class*="bundler"] td, [class*="bundler"] span, [class*="bundler"] div, [id*="bundler"] td, [id*="bundler"] span, [id*="bundler"] div, [data-price-val]'
  );
  
  const symbol = currencySymbols[targetCurrency] || '₹';
  
  priceElements.forEach(el => {
    const text = el.textContent.trim();
    if (!text) return;
    
    // Check if the text matches a price pattern (digits, spaces, currency signs)
    const priceRegex = /^(Rs\.|₹|\$|Rs|A\$|£|€|EUR|AUD|USD|INR)?\s*[\d,.-]+\s*(Retail)?$/i;
    if (!priceRegex.test(text)) return;
    
    let originalText = el.getAttribute('data-original-price-text');
    if (!originalText) {
      originalText = text;
      el.setAttribute('data-original-price-text', originalText);
    }
    
    // Explicitly strip "Rs." first to prevent its period from being parsed as a leading decimal point
    const cleanedText = originalText.replace(/Rs\./gi, '');
    const numbersOnly = cleanedText.replace(/[^\d.]/g, '');
    const inrValue = parseFloat(numbersOnly);
    if (!isNaN(inrValue)) {
      const convertedValue = convertPrice(inrValue, targetCurrency);
      const formattedValue = targetCurrency === 'JPY' 
        ? Math.round(convertedValue).toLocaleString('en-US') 
        : convertedValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
      const suffix = originalText.toLowerCase().includes('retail') ? ' (Retail)' : '';
      el.textContent = `${symbol} ${formattedValue}${suffix}`;
    }
  });
}

// Rewrite dropdown labels from (INR ₹) to native currency (Desktop & Mobile)
function updateDropdownLabels() {
  const items = document.querySelectorAll('.localization-country-item');
  items.forEach(item => {
    const countryCode = item.getAttribute('data-value');
    const link = item.querySelector('a');
    if (countryCode && link) {
      const currencyCode = countryToCurrencyMap[countryCode] || 'INR';
      const currencySymbol = currencySymbols[currencyCode] || '₹';
      
      const currentText = link.textContent.trim();
      const nameParts = currentText.split('(');
      const nameWithoutCurrency = nameParts[0].trim();
      
      link.textContent = `${nameWithoutCurrency} (${currencyCode} ${currencySymbol})`;
    }
  });

  // Rewrite custom mobile selector modal labels
  const mobileLabels = document.querySelectorAll('.mobile-country-name-label');
  mobileLabels.forEach(label => {
    const parentLi = label.closest('.mobile-country-item');
    const countryCode = parentLi ? parentLi.getAttribute('data-value') : null;
    if (countryCode) {
      const currencyCode = countryToCurrencyMap[countryCode] || 'INR';
      const currencySymbol = currencySymbols[currencyCode] || '₹';
      
      const currentText = label.textContent.trim();
      const nameParts = currentText.split('(');
      const nameWithoutCurrency = nameParts[0].trim();
      
      label.textContent = `${nameWithoutCurrency} (${currencyCode} ${currencySymbol})`;
    }
  });

  // Rewrite native select options for mobile view (fallback trigger compatibility)
  const mobileSelect = document.querySelector('.mobile-country-select');
  if (mobileSelect) {
    const options = mobileSelect.querySelectorAll('option');
    options.forEach(opt => {
      const countryCode = opt.value;
      if (countryCode) {
        const currencyCode = countryToCurrencyMap[countryCode] || 'INR';
        const currencySymbol = currencySymbols[currencyCode] || '₹';
        
        const currentText = opt.textContent.trim();
        const nameParts = currentText.split('(');
        const nameWithoutCurrency = nameParts[0].trim();
        
        opt.textContent = `${nameWithoutCurrency} (${currencyCode} ${currencySymbol})`;
      }
    });
  }
}

// Setup MutationObserver to watch for dynamic app widgets (like Bundler) and AJAX elements (like recommendations) being injected
function initAppMutationObserver() {
  const observer = new MutationObserver((mutations) => {
    let shouldConvert = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if node itself or any child matches price/recommendation selectors
            if (node.classList && (
              node.className.includes('bundler') || 
              node.className.includes('product') || 
              node.className.includes('recommendation') ||
              node.className.includes('price')
            )) {
              shouldConvert = true;
              break;
            }
            if (node.querySelector && (
              node.querySelector('.price-val, .compare-val, .product-card-price, .product-card-compare-price, .price, [class*="bundler"]')
            )) {
              shouldConvert = true;
              break;
            }
          }
        }
      }
      if (shouldConvert) break;
    }
    if (shouldConvert) {
      // Disconnect observer temporarily to prevent infinite loop of changes
      observer.disconnect();
      convertAllPricesOnPage();
      // Reconnect observer
      observeDOM();
    }
  });

  function observeDOM() {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  observeDOM();
}

// Initialize Dark Mode (Night Mode)
function initDarkMode() {
  const toggleBtns = document.querySelectorAll('.dark-mode-toggle-btn');
  const htmlEl = document.documentElement;
  
  // Set initial theme
  const savedTheme = localStorage.getItem('devar-theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  setTheme(savedTheme);
  
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const currentTheme = htmlEl.getAttribute('data-theme') || 'light';
      const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
      setTheme(newTheme);
    });
  });
  
  function setTheme(theme) {
    htmlEl.setAttribute('data-theme', theme);
    localStorage.setItem('devar-theme', theme);
    
    // Toggle sun/moon icons in all dark mode buttons on the page
    const moonIcons = document.querySelectorAll('.dark-mode-icon-moon');
    const sunIcons = document.querySelectorAll('.dark-mode-icon-sun');
    
    if (theme === 'dark') {
      moonIcons.forEach(i => i.style.display = 'none');
      sunIcons.forEach(i => i.style.display = 'block');
    } else {
      moonIcons.forEach(i => i.style.display = 'block');
      sunIcons.forEach(i => i.style.display = 'none');
    }
  }
}

// Initialize client-side dropdown country filter search (Desktop & Mobile)
function initCountrySearch() {
  // Desktop selector logic
  const searchInput = document.getElementById('CountrySearchInput');
  const countryItems = document.querySelectorAll('.localization-country-item');
  
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();
      
      countryItems.forEach(item => {
        const text = item.textContent.toLowerCase();
        if (text.includes(query)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
    
    // Clear search query and focus when selector is toggled open
    const trigger = document.querySelector('.country-selector-trigger');
    if (trigger) {
      trigger.addEventListener('click', () => {
        const list = document.getElementById('HeaderCountryList');
        if (list && list.style.display === 'none') {
          searchInput.value = '';
          countryItems.forEach(item => item.style.display = '');
          setTimeout(() => searchInput.focus(), 80);
        }
      });
    }
  }

  // Mobile full-screen search modal logic
  const mobileTrigger = document.querySelector('.mobile-region-trigger');
  const mobileModal = document.getElementById('MobileCountrySearchModal');
  const closeMobileModal = document.getElementById('CloseMobileCountryModal');
  const mobileSearchInput = document.getElementById('MobileCountrySearchInput');
  const mobileCountryItems = document.querySelectorAll('.mobile-country-item');
  
  if (mobileTrigger && mobileModal) {
    mobileTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      mobileModal.style.display = 'flex';
      if (mobileSearchInput) {
        mobileSearchInput.value = '';
        setTimeout(() => mobileSearchInput.focus(), 80);
      }
      mobileCountryItems.forEach(item => item.style.display = '');
    });
  }
  
  if (closeMobileModal && mobileModal) {
    closeMobileModal.addEventListener('click', () => {
      mobileModal.style.display = 'none';
    });
  }
  
  if (mobileSearchInput) {
    mobileSearchInput.addEventListener('input', function() {
      const query = this.value.toLowerCase().trim();
      mobileCountryItems.forEach(item => {
        const text = item.textContent.toLowerCase();
        if (text.includes(query)) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  }
}

// Dynamically calculate and update header heights to eliminate gaps
function initDynamicHeaderHeights() {
  const stickyHeader = document.querySelector('.luxury-header-sticky');
  const mainNav = document.querySelector('.header-main-nav-wrapper');
  const announcement = document.querySelector('.announcement-bar-container');
  
  function updateHeights() {
    if (mainNav) {
      const headerHeight = mainNav.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }
    
    if (announcement && announcement.style.display !== 'none') {
      const announcementHeight = announcement.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-height', '0px');
    }
  }
  
  // Run immediately
  updateHeights();
  
  // Use ResizeObserver for instant responsive updates (including theme customizer settings changes!)
  if (typeof ResizeObserver !== 'undefined' && stickyHeader) {
    const observer = new ResizeObserver(() => {
      updateHeights();
    });
    observer.observe(stickyHeader);
  }
  
  // Fallbacks
  window.addEventListener('load', updateHeights);
  window.addEventListener('resize', updateHeights);
}
